import { GatedAddressInput } from '@components/GatedAddressInput';
import { useSaveSalesforceWebToLead } from '@hooks/useSaveSalesforceWebToLead';
import * as api from '@lib/api';
import { addressAtom, googlePlaceIdAtom } from '@src/state';
import React, { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import ChartPreview from '../components/chart-preview';
import { ContentView } from '../components/content-view.styled';
import { Form } from '../components/form';
import { Footer, Subtitle, Title } from '../components/form.styled';
import PageView from '../components/page-view';
import { useAnalytics } from '../lib/analytics';
import { getContactNumber } from '../lib/util';
import * as styled from './enter-address.styled';

const EnterAddress: React.FC<{
    onNext: () => void;
    scrollTarget: React.RefObject<HTMLDivElement>;
}> = ({ onNext, scrollTarget }) => {
    const [address, setAddress] = useRecoilState(addressAtom);
    const [googlePlaceId, setGooglePlaceId] = useRecoilState(googlePlaceIdAtom);
    const saveSalesforceWebToLead = useSaveSalesforceWebToLead();
    const subtitle = 'Get a personalized income estimate';

    const utm = sessionStorage.getItem('utm_medium');
    const utmParam = utm ? JSON.parse(utm) : null;
    const [loading, isLoading] = useState(false);

    const analytics = useAnalytics();

    useEffect(() => {
        if (loading) {
            saveSalesforceWebToLead(undefined, googlePlaceId)
                .then(() => api.emitAnalytics('step-address-complete', analytics))
                .then(onNext)
                .finally(() => isLoading(false));
        }
    }, [address]);

    return (
        <PageView dataCy="enter-address" scrollTarget={scrollTarget}>
            <ContentView>
                {/* prettier-ignore */}
                <Form>
                    <Title>
                        {
                        `Discover
                        full-service
                        vacation rental
                        management`
                        }
                    </Title>
                        <Subtitle bold>
                            {subtitle}
                        </Subtitle>
                    <styled.Input>
                    <GatedAddressInput
                                autoFocus={true}
                                onSubmit={(addr, placeId) => {
                                        setAddress(addr)
                                        setGooglePlaceId(placeId)
                                        isLoading(true)
                                    }
                                }
                            />
                    </styled.Input>
                    <Footer>
                        Or connect with us at {getContactNumber(utmParam)}
                    </Footer>
                </Form>
                <ChartPreview title="Estimated income" />
            </ContentView>
        </PageView>
    );
};

export default EnterAddress;
